import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../modules';
import { TInspectorType } from '../modules/webforms/types';
import { ITab, IWebFormContent } from '@qodly/shared';

export const selectWebforms = createSelector(
  (state: AppState) => state.webforms,
  (webforms) => webforms,
);

export const selectComponents = createSelector(
  selectWebforms,
  (state) => state?.components || [],
);

export const selectInspector = createSelector(
  selectWebforms,
  (state) => state.inspector,
);

export const selectInspectedCSSClass = createSelector(
  selectInspector,
  (state) => state.css,
);

export const selectInspectedDatasource = createSelector(
  selectInspector,
  (state) => state.datasource,
);

export const selectTemplates = createSelector(
  selectWebforms,
  (state) =>
    state.templates || {
      data: [],
    },
);

export const selectTemplatesData = createSelector(
  selectTemplates,
  (state) => state.data || [],
);

export const selectCraftedComponent = (id: string) =>
  createSelector(selectComponents, (components) =>
    components.find((cmp) => cmp.id === id),
  );

export const selectInspectorStateByType = (type: TInspectorType) =>
  createSelector(selectInspector, (state) => state[type]);

export const selectDatasourcesTheme = createSelector(
  selectWebforms,
  (state) => state.datasources.theme,
);

export const selectClipBoard = createSelector(
  (state: AppState) => state.root,
  (root) => root.clipboard,
);

export const selectIsLoaded = createSelector(
  (state: AppState) => state.catalog,
  (state: AppState) => state.sharedDatasources,
  (state: AppState) => state.sharedCSS,
  (catalog, sharedDatasources, sharedCSS) =>
    [catalog.state, sharedDatasources.state, sharedCSS.state].every((state) =>
      ['loaded', 'error'].includes(state),
    ),
);

export const selectWebformMetadataByPath = (tabPath: string) =>
  createSelector(
    (state: AppState) => state.root,
    (root) => {
      const tab = root.tabs.find(
        ({ path }) => path === tabPath,
      ) as ITab<IWebFormContent>;
      return tab?.content?.metadata || {};
    },
  );

export const selectI18nCurrent = createSelector(
  (state: AppState) => state.webforms,
  ({ i18n }) => {
    return i18n.current;
  }
);
